module.exports = __webpack_public_path__ + "img/daikin_color_logo.ae3b5bee.svg";